/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NextCallerResponseModel } from '../../models/next-caller-response-model';

export interface PractitionerNextCallerGet$Params {
  lobbyId?: string;
}

export function practitionerNextCallerGet(http: HttpClient, rootUrl: string, params?: PractitionerNextCallerGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<NextCallerResponseModel>> {
  const rb = new RequestBuilder(rootUrl, practitionerNextCallerGet.PATH, 'get');
  if (params) {
    rb.query('lobbyId', params.lobbyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<NextCallerResponseModel>;
    })
  );
}

practitionerNextCallerGet.PATH = '/Practitioner/NextCaller';
